import { APPLICATION_ROUTES, FULL_ROUTES } from './routes';

const MODULES: Record<string, string> = {
  'exclusao-beneficiario': APPLICATION_ROUTES.EXCLUSAO_BENEFICIARIO,
  'alteracao-beneficiario': APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO,
  'inclusao-beneficiario': FULL_ROUTES.BENEF_NOVA_INCLUSAO_CONSULTA,
  'movimentacao-lote': APPLICATION_ROUTES.MOVIMENTACAO_LOTE,
  'reinclusao-beneficiario': APPLICATION_ROUTES.REINCLUSAO_BENEFICIARIO,
  'historico-solicitacoes': APPLICATION_ROUTES.HISTORICO_SOLICITACOES,
  'inconsistencia-sib': APPLICATION_ROUTES.INCONSISTENCIA_SIB,
  'faturas': APPLICATION_ROUTES.FATURAS,
  'folha-pagamento': APPLICATION_ROUTES.FOLHAS_PAGAMENTO,
  'mensalidades': APPLICATION_ROUTES.MENSALIDADES,
  'dossie-contrato': APPLICATION_ROUTES.DOSSIE_CONTRATO,
  'dossie-beneficiario': APPLICATION_ROUTES.DOSSIE_BENEFICIARIO,
  'analise-atendimentos': APPLICATION_ROUTES.ANALISE_ATENDIMENTOS,
  'historico-analises': APPLICATION_ROUTES.HISTORICO_ANALISES,
  'historico-autorizacao': APPLICATION_ROUTES.HISTORICO_AUTORIZACAO,
  'historico-requisicao': APPLICATION_ROUTES.HISTORICO_REQUISICOES,
  'dinamico': APPLICATION_ROUTES.DINAMICO,
  'relatorios': APPLICATION_ROUTES.RELATORIOS,
};

export default MODULES;
